import {settingsSvg as Icon__small__settingsSvg} from '../Icon__small/Icon__small--settings.js';
import {settingsSvg as Icon__xsmall__settingsSvg} from '../Icon__xsmall/Icon__xsmall--settings.js';

export var settings = {
  name: 'settings',
  category: 'icon',
  colorable: true,
  svg: Icon__small__settingsSvg,
  alt: {
    Icon__small: Icon__small__settingsSvg,
    Icon__xsmall: Icon__xsmall__settingsSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
